import { Drawer as BaseDrawer } from '@base-ui/react/drawer'

import { withPopupOpenMarker } from '@gto/ui/state-markers'

export const Trigger = ({ className, ...props }: BaseDrawer.Trigger.Props) => (
  <BaseDrawer.Trigger
    {...props}
    className={withPopupOpenMarker(className)}
  />
)
